import { useState } from 'react';

// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import usePlatformAdminAccess from 'hooks/usePlatformAdminAccess';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

function canShowMenuItem(item, hasPlatformAccess) {
  return item.access !== 'platform_admin' || hasPlatformAccess;
}

function filterMenuItems(items, hasPlatformAccess) {
  return items
    .filter((item) => canShowMenuItem(item, hasPlatformAccess))
    .map((item) => ({
      ...item,
      children: item.children ? filterMenuItems(item.children, hasPlatformAccess) : item.children
    }))
    .filter((item) => item.type !== 'group' || !item.children || item.children.length > 0);
}

export default function Navigation() {
  const [openGroupId, setOpenGroupId] = useState('group-overview');
  const { hasPlatformAccess } = usePlatformAdminAccess();

  const handleGroupToggle = (id) => {
    setOpenGroupId((currentId) => (currentId === id ? '' : id));
  };

  const navGroups = filterMenuItems(menuItem.items, hasPlatformAccess).map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} open={item.id === openGroupId || !item.title} onToggle={handleGroupToggle} />;
      default:
        return (
          <Typography key={item.id} variant="h6" sx={{ color: 'error.main', textAlign: 'center' }}>
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
